









import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import FAQItem from '@/components/molecules/FAQItem.vue'
import { State as FAQState } from '@/store/modules/faq'

export default Vue.extend({
  name: 'FAQ',
  components: {
    PageTitle,
    FAQItem
  },
  computed: {
    items(): FAQState['items'] {
      return this.$state.faq.items
    }
  },
  methods: {
    select(n: number) {
      this.$store.dispatch('faq/selectItem', { index: n })
    }
  }
})
